export default '\r\n';